import Navbar from '@/components/feature/Navbar';
import { useTranslation } from 'react-i18next';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import WhyYallabinaSection from './components/WhyYallabinaSection';
import ToursByCitySection from './components/ToursByCitySection';
import { toursFromHurghada, toursFromMarsaAlam } from '@/mocks/tours';

export default function Home() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <HeroSection />
        <WhyYallabinaSection />

        {/* Tours from Hurghada */}
        <ToursByCitySection
          sectionId="hurghada-tours"
          title={t('hurghada_tours_title')}
          subtitle={t('hurghada_tours_subtitle')}
          tours={toursFromHurghada}
          bgClass="bg-background-50"
        />

        {/* Tours from Marsa Alam */}
        <ToursByCitySection
          sectionId="marsa-alam-tours"
          title={t('marsa_alam_tours_title')}
          subtitle={t('marsa_alam_tours_subtitle')}
          tours={toursFromMarsaAlam}
          bgClass="bg-background-100"
        />
      </main>
      <Footer />
    </div>
  );
}